import React, { useEffect, useState } from "react";
import { useLoading } from "../../common/LoadingContext";
import { useNotificationContext } from "../../common/NotificationContext";
import TechnicalDocumentList from "./TechnicalDocumentList";
import { BASE_URL } from "../../utils/AppApiUrl";
import { useLocation } from "react-router-dom";
import {
  TechnicalDocumentListService,
  AllBrandListingService,
  categoryListingService,
  docTypeListingService,
  getAllDropDownService,
  getAllDropDownListService,
} from "../../services/TechnicalDocumentService";
import {
  departmentsListingService,
} from "../../services/UserOnboardingService";
import { ModelListing_By_BrickService } from "../../services/TechnicalDocumentService";
import { ModelDeptListing_By_BrickService } from "../../services/TechnicalDocumentService";
import useGlobalState from "../../Context";
import {
  brickListingOnSelectedBrandService,
  CategoryListOnSelectedBrandService,
 } from "../../services/ModelViewService";
import {
  BrickListingWithOrWithoutFamilyId,
  FamilyListingService,

} from "../../services/MasterDataManagementService";
const TechnicalDocument = () => {
  const { showNotification } = useNotificationContext();
  const { setLoading } = useLoading();
  const [techDocumentRecords, setTechDocumentRecords] = useState([]);
  const [totalElements, setTotalElements] = useState(0);
  const [brandList, setBrandList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [docTypeList, setDocTypeListing] = useState([]);
  const [allBrands, setAllBrands] = useState([]);
  const [modelList, setModelList] = useState([]);
  const [departmentList, setDepartMentList] = useState([]);
  const [brickListForUpload, setBrickListForUpload] = useState([]);
  const [searchClicked, setSearchClicked] = useState(false);
  const [isApiCalled, setIsApiCalled] = useState(false);
  const [noRecord, setNoRecord] = useState(false);
  const { state } = useLocation();
  const [{ auth }, dispatch] = useGlobalState();
  const loginUserType = auth.ldapParam.userType;
  const history = useLocation();
  const [categoryListOnBrandId, setCategoryListOnBrandId] = useState([]);
  const [productFamilyList, setProductFamilyList] = useState([]);
  const [_categoryListOnBrandId, _setCategoryListOnBrandId] = useState([]);
  const [brickList, setBrickList] = useState([]);
  const [brickDropdownList, setBrickDropDownList] = useState([]);
  const [familyList, setFamilyList] = useState([]);
  const [brandDropDownList, setBrandDropDownList] = useState([]);
  const [modelIdData, setModelIdData] = useState([]);
  const [deptIdData, setDeptIdData] = useState([]);
  const [selectedModelIds, setSelectedModelIds] = useState([]);
  const [selectedDeptIds, setSelectedDeptlIds] = useState([]);
  useEffect(() => {
    
    if (history.pathname === "/technical-document-view") {
      if (state) {
        setTechDocumentRecords(state?.content?.data);
        setTotalElements(state?.content?.data?.length);
      } else {
        setTechDocumentRecords([]);
        setTotalElements(0);
      }
    } else {
        const requestBody = {
        deptId: auth.ldapParam.deptId,
        userType: auth.ldapParam.userType,
        pageNumber: 0,
        pageSize: 10,
        
      };
      fetchTechnicalDocumentDetails(requestBody,"name", true);
    //  fetchBrandList();
    //  fetchCatSearchDropdownList();
     // fetchBrandSearchDropdownList();
     // fetchFamSearchDropdownList();
    //  fetchBrickSearchDropdownList();
      fetchAllDropDownList();
      fetchDocTypeList();
      setTechDocumentRecords([]);
      setTotalElements(0);
      fetchDepartmentsList()
    }
  }, [state]);

  const fetchTechnicalDocumentDetails = async (values, sortBy, isAsc) => {
    try {
      setLoading(true);
      setSearchClicked(true);
      setIsApiCalled(true);
      const requestBody = {
        pageNumber: values?.pageNumber ?? 0,
        pageSize: values?.pageSize ?? 10,
        sortDirection: isAsc ? "DESC" : "ASC",
        sortBy: sortBy,
        brandId: values?.brandId ?? null,
        categoryId: values?.categoryId ?? null,
        modelName: values?.modelName ?? null,
        docTypeId: values?.docTypeId ?? null,
        productFamilyId: values?.productFamilyId ?? null,
        brickId: values?.brickId ?? null,
        techDocDesc: values?.techDocDesc ?? null,
        deptId:  values?.deptId ?? null,
        userType:  values?.userType ?? null,
      };
  
      const response = await TechnicalDocumentListService(requestBody);
   
      if (response.statusCode === 6) {
        if (response.data.content?.length === 0) {
          setNoRecord(true);
        } else {
          setNoRecord(false);
        }
        setTechDocumentRecords(response.data.content);
        setTotalElements(response.data.totalElements);
      } else {
        showNotification("Error", response.message, "error");
      }
    } catch (err) {
      showNotification("Error", err.message ?? "Failed to fetch user details");
    } finally {
      setLoading(false);
    }
  };
  const fetchDepartmentsList = async (sortBy, isAsc,searchValue) => {
    try {
      setLoading(true);
      const requestBody = {
        pageSize: 100,
        pageNumber: 0,
        filterSearch:searchValue ? searchValue : null,
        active: 0,
        sortBy: "name",
        sortDirection: "DESC",
      };
   
      const response = await departmentsListingService(requestBody);
      if (response.statusCode === 6) {
        setDepartMentList(response.data.content);
      } else {
        showNotification("Error", response.message, "error");
      }
    } catch (err) {
      console.log("error", err);
      showNotification("Error", "fail to fetch Departments listing", "error");
    } finally {
      setLoading(false);
    }
  };
  const fetchBrickListWithorWithoutFamily = async (id) => {
    try {
      const obj = {
        pageNumber: 0,
        pageSize: 10,
        filterSearch: null,
        active: 0,
        sortDirection: "ASC",
        sortBy: "brickId",
        productFamilyId: id ? id : 0,
      };
      const brickListingResponse = await BrickListingWithOrWithoutFamilyId(obj);
   
      if (brickListingResponse.statusCode === 6) {
    
        setBrickList(brickListingResponse.data);
      } else {
        showNotification("Error", brickListingResponse.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
  
    }
  };
  const fetchModelsList = async (brickId, brandId) => {
    try {
      const response = await ModelListing_By_BrickService(brickId, brandId);
      if (response?.statusCode === 6) {
        setModelList(response?.data?.spareModel);
      } else {
        showNotification("Error", response.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
      // setLoading(false);
    }
  };
  const fetchAllBrandsList = async () => {
    try {
      const allBrandsListingResponse = await AllBrandListingService();
      if (allBrandsListingResponse.statusCode === 6) {
        setAllBrands(allBrandsListingResponse.data);
      } else {
        showNotification("Error", allBrandsListingResponse.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
  
    }
  };
  const fetchProductFamilyList = async (id) => {
    try {
      const obj = {
        pageNumber: 0,
        pageSize: 10,
        filterSearch: null,
        active: loginUserType === "Main Admin" ? 2 : 0,
        categoryId: id ? id : null,
        sortDirection: "DESC",
        sortBy: "productFamilyName",
      };
      const familyListingResponse = await FamilyListingService(obj);
      if (familyListingResponse.statusCode === 6) {
        setProductFamilyList(familyListingResponse.data);
      } else {
        showNotification("Error", familyListingResponse.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
 
    }
  };

  const fetchModelsDeptList = async (brickId, brandId,docName1) => {
    try {
      const response = await ModelDeptListing_By_BrickService(brickId, brandId,docName1);
      if (response?.statusCode === 6) {
        setModelList(response?.data?.spareModelResponse?.spareModel);
        const requestObj={
          docName :docName1
        }
          let model1 =  response?.data?.spareModelResponse?.spareModel.filter((val)=>{
            return response?.data?.modelAndDeptDetailsResponse?.modelIds.includes(val.modelId)
          })
          setModelIdData(model1);
          setSelectedModelIds(model1)
          let test =  departmentList.filter((val)=>{
            return response?.data?.modelAndDeptDetailsResponse?.deptIds.includes(val.departmentId)
          })
        
          setDeptIdData(test);
          setSelectedDeptlIds(test)
       
      } else {
        showNotification("Error", response.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
    }
  };
 
  const fetchBrandList = async () => {
    try {
      const brandListingResponse = await AllBrandListingService();
      if (brandListingResponse.statusCode === 6) {
        setBrandList(brandListingResponse.data);
      } else {
        showNotification("Error", brandListingResponse.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
 
    }
  };

  const fetchBrandSearchDropdownList = async (
    brandId,
    brickId,
    productFamilyId,
    categoryId
  ) => {
    try {
      const response = await getAllDropDownService(
        brandId,
        brickId,
        productFamilyId,
        categoryId,
        4
      );
     
      if (response.statusCode === 6) {
   
        setBrandDropDownList(response.data);
      } else {
        showNotification("Error", response.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
 
    }
  };

  const fetchAllDropDownList = async () => {
    try {
      const response = await getAllDropDownListService();
     
      if (response.statusCode === 6) {
   
        setFamilyList(response.data.family);
        setBrandDropDownList(response.data.brand);
        setCategoryList(response.data.category);
        setBrickDropDownList(response.data.brick);
      } else {
        showNotification("Error", response.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
 
    }
  };

  const fetchFamSearchDropdownList = async (
    brandId,
    brickId,
    productFamilyId,
    categoryId
  ) => {
    try {
      const response = await getAllDropDownService(
        brandId,
        brickId,
        productFamilyId,
        categoryId,
        2
      );
      if (response.statusCode === 6) {
 
        setFamilyList(response.data);
      } else {
        showNotification("Error", response.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
 
    }
  };

  const fetchCatSearchDropdownList = async (
    brandId,
    brickId,
    productFamilyId,
    categoryId
  ) => {
    try {
      const response = await getAllDropDownService(
        brandId,
        brickId,
        productFamilyId,
        categoryId,
        1
      );
      if (response.statusCode === 6) {
        setCategoryList(response.data);
      } else {
        showNotification("Error", response.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
    }
  };

  const fetchBrickSearchDropdownList = async (
    brandId,
    brickId,
    productFamilyId,
    categoryId
  ) => {
    try {
      const response = await getAllDropDownService(
        brandId,
        brickId,
        productFamilyId,
        categoryId,
        3
      );
      if (response.statusCode === 6) {
        setBrickDropDownList(response.data);
      } else {
        showNotification("Error", response.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
    }
  };

  const fetchDocTypeList = async () => {
    try {
      const docTypeListingResponse = await docTypeListingService(0);
      if (docTypeListingResponse.statusCode === 6) {
        setDocTypeListing(docTypeListingResponse.data.docParams);
      } else {
        showNotification("Error", docTypeListingResponse.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
    }
  };

  const fetchCategoryList = async () => {
    try {
      const requestBody = {
        pageSize: 200,
        pageNumber: 0,
        filterSearch: null,
        active: 0,
        sortBy: "categoryName",
        sortDirection: "DESC",
      };
      const categoryListingResponse = await categoryListingService(requestBody);
      if (categoryListingResponse.statusCode === 6) {
        setCategoryList(categoryListingResponse.data.content);
      } else {
        showNotification("Error", categoryListingResponse.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
    
    }
  };
  const fetchBrickListOnSelectedBrandForUpload = async (id) => {
    try {
      const brickListingResponse = await brickListingOnSelectedBrandService(id);
      if (brickListingResponse.statusCode === 6) {
        setBrickListForUpload(brickListingResponse.data);
      } else {
        showNotification("Error", brickListingResponse.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
    
    }
  };

  const fetchCategoryListOnSelectedBrand = async (id) => {
    try {
      const response = await CategoryListOnSelectedBrandService(id);
      if (response.statusCode === 6) {
        setCategoryListOnBrandId(response.data);
      } else {
        showNotification("Error", response.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
    }
  };

  const handleTableChanges = async (
    paginationValues,
    isUpdate,
    sortValue,
    orderBy,
    brandSearch,categorySearch,familySearch,brickSearch,typeSearch,modelSearchValue,techDocSearch
  ) => {
    try {
      setLoading(true);
      const requestBody = {
        pageNumber: paginationValues?.pageNumber ?? 0,
        pageSize: paginationValues?.pageSize ?? 10,
        sortBy: orderBy,
        sortDirection: sortValue === null ? "DESC" : sortValue,
        brandId: brandSearch ?? null,
        categoryId: categorySearch ?? null,
        productFamilyId:familySearch ?? null,
        brickId:brickSearch ?? null,
        modelName:modelSearchValue ?? null,
        techDocDesc:techDocSearch ?? null,
       // fgCode: fgCode ?? null,
       // name: name ?? null,
        docTypeId: typeSearch?? null,
        deptId: auth.ldapParam.deptId,
        userType: auth.ldapParam.userType,
      };
      const response = await TechnicalDocumentListService(requestBody);
      if (response.statusCode === 6) {
        if (isUpdate) {
          setTechDocumentRecords([
            ...techDocumentRecords,
            ...response.data.content,
          ]);
        } else {
          setTechDocumentRecords(response.data.content);
        }
      } else {
        showNotification("Error", response.message, "error");
      }
    } catch (e) {
      showNotification("Error", "Failed to fetch site filter search data");
    } finally {
      setLoading(false);
  
    }
  };

  return (
    <>
      <TechnicalDocumentList
        techDocumentRecords={techDocumentRecords}
        handleTableChanges={handleTableChanges}
        fetchTechnicalDocumentDetails={fetchTechnicalDocumentDetails}
        totalElements={totalElements}
        setTechDocumentRecords={setTechDocumentRecords}
        setTotalElements={setTotalElements}
        BASE_URL={BASE_URL}
        brandList={brandList}
        categoryList={categoryList}
        docTypeList={docTypeList}
        setLoading={setLoading}
        fetchAllBrandsList={fetchAllBrandsList}
        modelList={modelList}
        fetchModelsDeptList={fetchModelsDeptList}
        fetchModelsList={fetchModelsList}
        allBrands={allBrands}
        fetchBrickListOnSelectedBrandForUpload={
          fetchBrickListOnSelectedBrandForUpload
        }
        brickListForUpload={brickListForUpload}
        showNotification={showNotification}
        state={state}
        searchClicked={searchClicked}
        setSearchClicked={setSearchClicked}
        isApiCalled={isApiCalled}
        setIsApiCalled={setIsApiCalled}
        noRecord={noRecord}
        fetchDocTypeList={fetchDocTypeList}
        setCategoryListOnBrandId={setCategoryListOnBrandId}
        productFamilyList={productFamilyList}
        fetchCategoryListOnSelectedBrand={fetchCategoryListOnSelectedBrand}
        categoryListOnBrandId={categoryListOnBrandId}
        fetchProductFamilyList={fetchProductFamilyList}
        fetchBrickListWithorWithoutFamily={fetchBrickListWithorWithoutFamily}
        brickList={brickList}
        brandDropDownList={brandDropDownList}
        familyList={familyList}
        brickDropdownList={brickDropdownList}
        fetchBrandSearchDropdownList={fetchBrandSearchDropdownList}
        fetchCatSearchDropdownList={fetchCatSearchDropdownList}
        fetchFamSearchDropdownList={fetchFamSearchDropdownList}
        fetchBrickSearchDropdownList={fetchBrickSearchDropdownList}
        departmentList = {departmentList}
        modelIdData = {modelIdData}
        deptIdData = {deptIdData}
        selectedModelIds={selectedModelIds}
        selectedDeptIds={selectedDeptIds}
        setSelectedModelIds = {setSelectedModelIds}
        setSelectedDeptlIds = {setSelectedDeptlIds}
         setModelIdData ={setModelIdData}
        setDeptIdData = {setDeptIdData}
      />
    </>
  );
};
export default TechnicalDocument;
